import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { XmlparseService } from '../xml/xmlparse.service';

import { AlertService } from "../../services/alert/alert.service";
import { report } from "../../models/reports/report";
import { reportindex } from "../../models/reports/reportindex";
import { IceTypes } from "../../models/icetypes";
import { Iceutility } from "../../services/iceutility";
import { LoginService } from '../../login/login.service';

declare var require: any;

@Injectable({
  providedIn: 'root'
})
export class OrderService extends XmlparseService {

  constructor(private http: HttpClient, private alertSvc: AlertService, private loginSvc: LoginService) {
    super(alertSvc, loginSvc);
  }

  getOrders(useAPI: string, act: string, keywords, start, due, searchtype, nextrecord, totalrecord, ordertype, minimalData: boolean, ptAct: string = ""): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Order service is not configured.";
    if (useAPI == null || useAPI.length == 0) throw "Use API is required.";

    let url = envs[currentEnv].icemedx_api + "/" + useAPI + "?domain=" + act + "&data=orderlist" + "&patientdomain=" + ptAct + "&key=&subkeys=searchprovider:;start:" + start + ";due:" + due + ";keywords:;searchtype:" + searchtype + ";next_start:" + nextrecord + ";total_records:" + totalrecord + ";minimal_data:" + minimalData.toString() + "&key=&acttype=";
    return this.http.get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["ORDER_ENTRY_INDEX"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );

  }

  static getStatus(ts: IceTypes.orderentrystatus): string {
    switch (ts) {
      case IceTypes.orderentrystatus.oestatusComplete:
        return "Complete";
      case IceTypes.orderentrystatus.oestatusWaiting:
        return "Waiting";
      case IceTypes.orderentrystatus.oestatusRendered:
        return "Administered (Rendered)";
      case IceTypes.orderentrystatus.oestatusPartiallyRendered:
        return "Partially Administered (Rendered)";
      case IceTypes.orderentrystatus.oestatusNotRendered:
        return "Not Administered (Rendered)";
      case IceTypes.orderentrystatus.oestatusCancelled:
        return "Cancelled";
      case IceTypes.orderentrystatus.oestatusInprogress:
        return "Inprogress";
      case IceTypes.orderentrystatus.oestatusOnhold:
        return "Onhold";
      case IceTypes.orderentrystatus.oestatusIncomplete:
        return "Incomplete";
      case IceTypes.orderentrystatus.oestatusAuthorizationRequired:
        return "Authorization Required";
      case IceTypes.orderentrystatus.oestatusApproved:
        return "Approved";
      case IceTypes.orderentrystatus.oestatusRefused:
        return "Refused";
      case IceTypes.orderentrystatus.oestatusHighPriority:
        return "High Priority (STAT)";
      case IceTypes.orderentrystatus.oestatusSignatureRequired:
        return "Signature Required";
      case IceTypes.orderentrystatus.oestatusVerbalOrder:
        return "Verbal Order";
      case IceTypes.orderentrystatus.oestatusDenied:
        return "Denied";
      case IceTypes.orderentrystatus.oestatusApprovedWithChanges:
        return "Approved With Changes";
      case IceTypes.orderentrystatus.oestatusDeniedNewPrescriptionToFollow:
        return "Denied New Prescription To Follow";
      case IceTypes.orderentrystatus.oestatusTransactionPending:
        return "Sent and Pending";
      case IceTypes.orderentrystatus.oestatusTransactionError:
        return "Transaction Error";
      case IceTypes.orderentrystatus.oestatusTransactionAccepted:
        return "Received and Accepted";
      case IceTypes.orderentrystatus.oestatusTransactionReceivedWithError:
        return "Received with Error";
      case IceTypes.orderentrystatus.oestatusCancelPending:
        return "Cancel Pending";
      case IceTypes.orderentrystatus.oestatusCancelError:
        return "Cancel Error";
      case IceTypes.orderentrystatus.oestatusCancelApproved:
        return "Cancel Approved";
      case IceTypes.orderentrystatus.oestatusFollowUpRequest:
        return "Follow-Up Request";
      case IceTypes.orderentrystatus.oestatusFillIndicator:
        return "Fill Indicator";
      case IceTypes.orderentrystatus.oestatusCancelDenied:
        return "Cancel Denied";
      case IceTypes.orderentrystatus.oestatusTransferred:
        return "Transferred";
    }
    return "Unknown";
  }

  static getServiceLevel(sl: IceTypes.ServiceLevel): string {
    switch (sl) {
      case IceTypes.ServiceLevel.svcLevelNew:
        return "New Rx";
      case IceTypes.ServiceLevel.svcLevelRefill:
        return "Refill";
      case IceTypes.ServiceLevel.svcLevelChange:
        return "Change";
      case IceTypes.ServiceLevel.svcLevelRxFill:
        return "RxFill";
      case IceTypes.ServiceLevel.svcLevelCancel:
        return "Cancel";
      case IceTypes.ServiceLevel.svcLevelMedHistory:
        return "Med. History";
      case IceTypes.ServiceLevel.svcLevelReSupp:
        return "Re-Supp.";
      case IceTypes.ServiceLevel.svcLevelCensus:
        return "Census";
      case IceTypes.ServiceLevel.svcLevelCCR:
        return "CCR";
      case IceTypes.ServiceLevel.svcLevelControlledSubstance:
        return "Controlled Substance";
      case IceTypes.ServiceLevel.svcLevelCIMessage:
        return "CI Message";
      case IceTypes.ServiceLevel.svcLevelCIEvent:
        return "CI Event";
      case IceTypes.ServiceLevel.svcLevelePA:
        return "PA";
      case IceTypes.ServiceLevel.svcLevelLongTermCare:
        return "Long Term Care";
      case IceTypes.ServiceLevel.svcLevelRxFillIndicatorChange:
        return "Rx Fill Indicator Change";
      case IceTypes.ServiceLevel.svcLevelDrugAdministration:
        return "Drug Administration";
      case IceTypes.ServiceLevel.svcLevelNewRxRequest:
        return "New Rx Request";
      case IceTypes.ServiceLevel.svcLevelNewRxResponseDenied:
        return "New Rx Response Denied";
      case IceTypes.ServiceLevel.svcLevelRecertification:
        return "Re-certification";
      case IceTypes.ServiceLevel.svcLevelPatMedBenefitCheck:
        return "Pat. Med. Benefit Check";
      case IceTypes.ServiceLevel.svcLevelSpecialty:
        return "Specialty";
      case IceTypes.ServiceLevel.svcLevelRxTransfer:
        return "Rx Transfer";
      case IceTypes.ServiceLevel.svcLevelSPOAutoEnrollment:
        return "SPO Auto Enrollment";
    }
    return "None";
  }

}
